import { Controller } from "@hotwired/stimulus";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../selectizeHelper";
import { TourConstants } from "../_generated/TourConstants";

export default class DetailAdditionalInformationController extends Controller {
    static targets = [
        "tourType",
        "selectColor",
        "hexColor",
        "automaticColor",
        "colorPicker"
    ];

    readonly tourTypeTarget!: HTMLSelectElement;
    readonly selectColorTarget!: HTMLSelectElement;
    readonly hexColorTarget!: HTMLInputElement;
    readonly automaticColorTarget!: HTMLElement;
    readonly colorPickerTarget!: HTMLInputElement;

    connect() {
        const tourType = $(this.tourTypeTarget);
        selectize(tourType, {
            onChange: () => $(this.tourTypeTarget).valid(),
            score: getScoreFunctionPreservingOrderInSearch
        });
    }

    colorSelected(event: EventWithColorParam) {        
        const selectedColorSpan = event.currentTarget as HTMLSpanElement
        this.selectColorTarget.innerHTML = selectedColorSpan.innerHTML;
        this.hexColorTarget.value = event.params.color;
        this.colorPickerTarget.value = event.params.color;
    }

    hexColorModified() {
        if (this.hexColorTarget.value === "") {
            this.selectColorTarget.innerHTML = this.automaticColorTarget.innerHTML;
            return;
        }

        if (!this.hexColorTarget.value.match(TourConstants.colorRegexPattern)) return;

        const colorBox = this.getSelectedColorBox();
        colorBox.innerText = "";
        colorBox.style.backgroundColor = this.hexColorTarget.value;
        this.colorPickerTarget.value = this.hexColorTarget.value;
    }

    private getSelectedColorBox(): HTMLElement {
        const colorBox = this.selectColorTarget.querySelector(".color-box") as HTMLElement;
        if (!colorBox) throw new Error("Cannot find color-box.");
        return colorBox;
    }

    pickColor(event: Event) {
        event.preventDefault();
        this.colorPickerTarget.click();
    }

    colorPicked() {
        const colorBox = this.getSelectedColorBox();
        colorBox.style.backgroundColor = this.colorPickerTarget.value;
        this.hexColorTarget.value = this.colorPickerTarget.value;
    }
}

interface EventWithColorParam {
    currentTarget: any;
    params: { color: string }
}
